import {getAmplitudeDeviceId, getAmplitudeSessionId} from "./init_amplitude";

// 30 minutes — matches Amplitude's default session timeout so that a user who stays on a page
// before crossing domains still carries over the same device/session ID.
const AMP_CROSS_DOMAIN_LINK_TTL_MS = 30 * 60 * 1000;

export const initAmplitudeCrossDomainTracking = (targetDomains: string[]): void => {
    if (typeof document === "undefined") {
        return;
    }

    document.addEventListener("mousedown", (event) => {
        const anchor = (event.target as Element).closest("a");

        if (!anchor?.href) {
            return;
        }

        let url: URL;
        try {
            url = new URL(anchor.href);
        } catch {
            return;
        }

        if (!isCrossDomainTarget(url, targetDomains)) {
            return;
        }

        decorateUrlWithAmplitudeParams(url);
        anchor.href = url.toString();
    });
};

export const appendAmplitudeCrossDomainParams = (urlString: string, targetDomains: string[]): string => {
    if (urlString.startsWith("/")) {
        return decorateRelativeUrlWithAmplitudeParams(urlString);
    }

    let url: URL;

    try {
        url = new URL(urlString);
    } catch {
        return urlString;
    }

    if (!isCrossDomainTarget(url, targetDomains)) {
        return urlString;
    }

    decorateUrlWithAmplitudeParams(url);

    return url.toString();
};

export const getRedirectUrlWithTopLevelAmpParams = (currentUrl: string): string | null => {
    const url = new URL(currentUrl);

    if (url.searchParams.has("ampDeviceId")) {
        return null;
    }

    const next = url.searchParams.get("next");
    if (!next) {
        return null;
    }

    const nestedUrl = new URL(next, url.origin);
    const ampDeviceId = nestedUrl.searchParams.get("ampDeviceId");
    if (!ampDeviceId) {
        return null;
    }

    url.searchParams.set("ampDeviceId", ampDeviceId);

    const ampSessionId = nestedUrl.searchParams.get("ampSessionId");
    if (ampSessionId) {
        url.searchParams.set("ampSessionId", ampSessionId);
    }

    const ampTimestamp = nestedUrl.searchParams.get("ampTimestamp");
    if (ampTimestamp) {
        url.searchParams.set("ampTimestamp", ampTimestamp);
    }

    return url.toString();
};

export const cleanAmplitudeParamsFromUrl = (): void => {
    if (typeof window === "undefined") {
        return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete("ampDeviceId");
    url.searchParams.delete("ampSessionId");
    url.searchParams.delete("ampTimestamp");

    if (url.toString() !== window.location.href) {
        history.replaceState(null, "", url.toString());
    }
};

const isCrossDomainTarget = (url: URL, targetDomains: string[]): boolean => {
    return targetDomains.some((domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`)) && url.hostname !== window.location.hostname;
};

const decorateRelativeUrlWithAmplitudeParams = (urlString: string): string => {
    const deviceId = getAmplitudeDeviceId();

    if (!deviceId) {
        return urlString;
    }

    const sessionId = getAmplitudeSessionId();
    const separator = urlString.includes("?") ? "&" : "?";

    let result = `${urlString}${separator}ampDeviceId=${encodeURIComponent(deviceId)}&ampTimestamp=${Date.now() + AMP_CROSS_DOMAIN_LINK_TTL_MS}`;
    if (sessionId !== undefined) {
        result += `&ampSessionId=${sessionId}`;
    }

    return result;
};

const decorateUrlWithAmplitudeParams = (url: URL): void => {
    const deviceId = getAmplitudeDeviceId();

    if (!deviceId) {
        return;
    }

    const sessionId = getAmplitudeSessionId();
    url.searchParams.set("ampDeviceId", deviceId);
    url.searchParams.set("ampTimestamp", String(Date.now() + AMP_CROSS_DOMAIN_LINK_TTL_MS));
    if (sessionId !== undefined) {
        url.searchParams.set("ampSessionId", String(sessionId));
    }
};
import {getAmplitudeDeviceId, getAmplitudeSessionId} from "./init_amplitude";

// 30 minutes — matches Amplitude's default session timeout so that a user who stays on a page
// before crossing domains still carries over the same device/session ID.
const AMP_CROSS_DOMAIN_LINK_TTL_MS = 30 * 60 * 1000;

export const initAmplitudeCrossDomainTracking = (targetDomains: string[]): void => {
    if (typeof document === "undefined") {
        return;
    }

    document.addEventListener("mousedown", (event) => {
        const anchor = (event.target as Element).closest("a");

        if (!anchor?.href) {
            return;
        }

        let url: URL;
        try {
            url = new URL(anchor.href);
        } catch {
            return;
        }

        if (!isCrossDomainTarget(url, targetDomains)) {
            return;
        }

        decorateUrlWithAmplitudeParams(url);
        anchor.href = url.toString();
    });
};

export const appendAmplitudeCrossDomainParams = (urlString: string, targetDomains: string[]): string => {
    if (urlString.startsWith("/")) {
        return decorateRelativeUrlWithAmplitudeParams(urlString);
    }

    let url: URL;

    try {
        url = new URL(urlString);
    } catch {
        return urlString;
    }

    if (!isCrossDomainTarget(url, targetDomains)) {
        return urlString;
    }

    decorateUrlWithAmplitudeParams(url);

    return url.toString();
};

export const getRedirectUrlWithTopLevelAmpParams = (currentUrl: string): string | null => {
    const url = new URL(currentUrl);

    if (url.searchParams.has("ampDeviceId")) {
        return null;
    }

    const next = url.searchParams.get("next");
    if (!next) {
        return null;
    }

    const nestedUrl = new URL(next, url.origin);
    const ampDeviceId = nestedUrl.searchParams.get("ampDeviceId");
    if (!ampDeviceId) {
        return null;
    }

    url.searchParams.set("ampDeviceId", ampDeviceId);

    const ampSessionId = nestedUrl.searchParams.get("ampSessionId");
    if (ampSessionId) {
        url.searchParams.set("ampSessionId", ampSessionId);
    }

    const ampTimestamp = nestedUrl.searchParams.get("ampTimestamp");
    if (ampTimestamp) {
        url.searchParams.set("ampTimestamp", ampTimestamp);
    }

    return url.toString();
};

export const cleanAmplitudeParamsFromUrl = (): void => {
    if (typeof window === "undefined") {
        return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete("ampDeviceId");
    url.searchParams.delete("ampSessionId");
    url.searchParams.delete("ampTimestamp");

    if (url.toString() !== window.location.href) {
        history.replaceState(null, "", url.toString());
    }
};

const isCrossDomainTarget = (url: URL, targetDomains: string[]): boolean => {
    return targetDomains.some((domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`)) && url.hostname !== window.location.hostname;
};

const decorateRelativeUrlWithAmplitudeParams = (urlString: string): string => {
    const deviceId = getAmplitudeDeviceId();

    if (!deviceId) {
        return urlString;
    }

    const sessionId = getAmplitudeSessionId();
    const separator = urlString.includes("?") ? "&" : "?";

    let result = `${urlString}${separator}ampDeviceId=${encodeURIComponent(deviceId)}&ampTimestamp=${Date.now() + AMP_CROSS_DOMAIN_LINK_TTL_MS}`;
    if (sessionId !== undefined) {
        result += `&ampSessionId=${sessionId}`;
    }

    return result;
};

const decorateUrlWithAmplitudeParams = (url: URL): void => {
    const deviceId = getAmplitudeDeviceId();

    if (!deviceId) {
        return;
    }

    const sessionId = getAmplitudeSessionId();
    url.searchParams.set("ampDeviceId", deviceId);
    url.searchParams.set("ampTimestamp", String(Date.now() + AMP_CROSS_DOMAIN_LINK_TTL_MS));
    if (sessionId !== undefined) {
        url.searchParams.set("ampSessionId", String(sessionId));
    }
};
